import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  error: {
    defaultMessage: 'Something went wrong. Please see your desktop browser for details.',
    id: 'HandoffError.error',
  },
});
